import { Segments } from '@models';

export const SegmentTypeLabel = {
  [Segments.TypeEnum.OPERATION]: 'Operação',
  [Segments.TypeEnum.BEHAVIOUR]: 'Comportamento',
  [Segments.TypeEnum.BUSINESS]: 'Negócio',
};
